import { Component, OnDestroy, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DashboardService } from '../_services/dashboard.service';
import * as XLSX from 'xlsx';
import * as FILESAVER from 'file-saver';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-student-attendance-report',
  templateUrl: './student-attendance-report.component.html',
  styleUrls: ['./student-attendance-report.component.scss']
})
export class StudentAttendanceReportComponent implements OnInit, OnDestroy {

  tableControls: any = { data: [] };
  reportFilter;
  loading = true;
  presentCount = 0;
  absentCount = 0;
  national_id;
  studentImage;
  studentName;
  student_id;
  filterSub;
  printSub;
  dataArray = [];
  modalOpen = false;
  currLang;
  constructor(
    private dashboardService: DashboardService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private router: Router) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.filterSub = new Subscription();
    this.printSub = new Subscription();
  }

  ngOnDestroy(): void {
    this.filterSub.unsubscribe();
    this.printSub.unsubscribe();
  }


  finishedLoading() {
    this.loading = false;
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    $(document).on('hidden.bs.modal', '#studentAttendanceReport', () => {
      // this.dashboardService.setInitFilter();
      this.filterSub.unsubscribe();
      this.modalOpen = false;
    })

    $(document).on('shown.bs.modal', '#studentAttendanceReport', () => {
      this.modalOpen = true;
    })

    this.dashboardService.getModalData().subscribe((res: any) => {
      this.dataArray = [];

      if (res !== null) {
        this.studentImage = res.image_path;
        this.studentName = res.name;
        this.student_id = res.national_id;
        this.presentCount = res.attendance_present_count;
        this.absentCount = res.attendance_absent_count;
        res.attendance.map(oneAttendance => {
          this.dataArray.push({
            date: oneAttendance.date,
            present: oneAttendance.status.name === 'present' || oneAttendance.status.name === 'late' ? true : null,
            absent: oneAttendance.status.name === "absent" ? true : null,
          })
        })
        this.translate.get('init').subscribe(res => {
          this.setTableControls();
        });
        this.translate.onLangChange.subscribe(res => {
          this.setTableControls();
        })
      }
      this.loading = false;
    })

    let p = this.dashboardService.getDownloadData().subscribe((res: any) => {
      if (res && this.router.url.split('/')[2] === 'attendance-reports' && this.modalOpen) {
        let workBook = XLSX.utils.book_new();
        workBook.SheetNames.push('test sheet');
        let valuesToBeExported = [];
        this.dataArray.map(data => {
          valuesToBeExported.push(data)
        })

        let ws_Data = valuesToBeExported;
        let ws = XLSX.utils.json_to_sheet(ws_Data);
        workBook.Sheets['test sheet'] = ws;
        let workBookOut = XLSX.writeFile(workBook, 'book.xlsx');

        function s2ab(s) {
          let buf = new ArrayBuffer(s.length);
          let view = new Uint8Array(buf);
          for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
          return buf;
        }
        $("#button-a").click(function () {
          FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
        });
      }
    })
    this.printSub.add(p);



  }

  setTableControls() {
    this.tableControls = {
      selection: false,
      paging: false,
      view: 'list',
      pagination: false,
      columns: [
        {
          name: this.translate.instant('student-attendance.date'),
          sort: false,
          type: "string",
          source: "date"
        },
        {
          name: this.translate.instant('student-attendance.present'),
          sort: false,
          type: "showIcon",
          source: "present"
        },
        {
          name: this.translate.instant('student-attendance.absent'),
          sort: false,
          type: "falseIcon",
          source: "absent"
        }
      ],
      data: this.dataArray
    }
  }
  getImage() {
    return environment.img_url + this.studentImage;
  }

  tableEventHandeler(event) {

  }
}